module.exports = __webpack_public_path__ + "img/521-42dfb3.png";